import { colors, fonts } from '@grupoboticario/flora-tokens/casaMagalhaesOceano/web/ds'

export const casaMagalhaesOceano = {
  colors,
  fonts,
}
